import React, { useEffect } from 'react';
import { useCadastro } from '../../hook/cadastroArvore';
import { useDispatch } from 'react-redux';
import {
  Dialog,
  IconButton,
  Typography,
  DialogBody,
  DialogHeader,
  DialogFooter,
} from '@material-tailwind/react';

import { XMarkIcon } from '@heroicons/react/24/outline';
import { useForm } from 'react-hook-form';
import InputGlobal from '../InputGlobal';
import SelectGlobal from '../SelectGlobal';
import ButtonGlobal from '../ButtonGlobal';
import bgRadiantBlue from '../bgRadiantBlue';
import { getEquipamentosAr } from '../../slices/productSlice';
import MsgSucess from '../MsgSucess';

export function AddModalInputs({ modal, handleModal, id }) {
  const {
    register,
    handleSubmit,
    reset,
    control,
    clearErrors,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const { result, patch, resetResultEquip } = useCadastro();

  const criticidadeEquipamento = [
    { id: 'A', nome: 'CRITICA' },
    { id: 'B', nome: 'ALTA' },
    { id: 'C', nome: 'MEDIA' },
    { id: 'D', nome: 'MODERADA' },
    { id: 'E', nome: 'BAIXA' },
    { id: 'F', nome: 'LEVE' },
  ];
  const onSubmit = (data) => {
    const newData = { ...data, maquinario: id };
    patch(newData);
  };

  useEffect(() => {
    return () => clearErrors();
  }, []);

  const resetInfo = () => {
    reset();
    dispatch(getEquipamentosAr(id));
    resetResultEquip();
    handleModal();
  };

  return (
    <>
      <Dialog
        size="sm"
        open={modal}
        handler={resetInfo}
        className={`p-4 bg-lightMenu dark:bg-none dark:bg-darkColorBg`}
      >
        <DialogHeader className="relative m-0 block">
          <Typography variant="h3" color="white">
            Cadastrar Equipamento
          </Typography>
          <IconButton
            size="sm"
            color="white"
            variant="text"
            className="!absolute right-3.5 top-3.5"
            onClick={resetInfo}
          >
            <XMarkIcon className="h-4 w-4 stroke-2" />
          </IconButton>
        </DialogHeader>
        <DialogBody className="space-y-4 pb-6">
          <form className="flex flex-col gap-5">
            <div>
              <InputGlobal
                formCamp="nome"
                type="text"
                label="Nome "
                placeholder="Nome do equipamento"
                register={register}
                validations={{ required: true }}
                required={true}
                errors={errors?.nome ? errors : false}
                css="w-full"
                error={result.error}
              />
            </div>
            <div>
              <InputGlobal
                formCamp="tag"
                type="text"
                label="Tag "
                placeholder="Tag do equipamento"
                register={register}
                validations={{ required: true }}
                required={true}
                errors={errors?.tag ? errors : false}
                css="w-full"
                error={result.error}
              />
            </div>
            <div>
              <SelectGlobal
                defaut={'D'}
                formCamp="criticidade"
                label="Criticidade"
                array={criticidadeEquipamento}
                errors={!!errors.criticidade ? errors : false}
                control={control}
                css=""
                cssDiv="w-full tex-black"
              />
            </div>
          </form>
        </DialogBody>
        <DialogFooter>
          <ButtonGlobal
            className="ml-auto"
            click={handleSubmit(onSubmit)}
            color="blue"
            text={'Adicionar'}
          />
        </DialogFooter>
        {result?.sucess && <MsgSucess reset={resetInfo} />}
      </Dialog>
    </>
  );
}
